<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt">This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="crt"><span class="small">ONE OF THOSE MALIBU NIGHTS.</span> Copyright © 2008 by Elizabeth Adler. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="crt"><a class="pubhlink" href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="crt">Design by Sarah Gubkin</p>
<p class="crt"><span class="small">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</span></p>
<p class="crt">Adler, Elizabeth (Elizabeth A.)<br/>   One of those Malibu nights / Elizabeth Adler.—1st ed.<br/>        p.    cm.<br/>   ISBN-13: 978-0-312-36449-6<br/>   ISBN-10: 0-312-36449-0<br/>1. Private investigators—Fiction. 2. Actresses—Fiction. 3. Americans—Foreign countries—Fiction. 4. California—Fiction. 5. Mexico—Fiction. 6. Rome (Italy)—Fiction. 7. France—Fiction. I. Title.<br/>   PR6051.D56O54 2008b<br/>   823′.914—dc22                                                2008010708</p>
<p class="crt">First Edition: July 2008</p>
<p class="crt">10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312364496_epub_cop_r1.vue?6801c5bb